import { render, staticRenderFns } from "./SolutionsSlide.vue?vue&type=template&id=67bfc110&scoped=true"
import script from "./SolutionsSlide.vue?vue&type=script&lang=ts"
export * from "./SolutionsSlide.vue?vue&type=script&lang=ts"
import style0 from "./SolutionsSlide.vue?vue&type=style&index=0&id=67bfc110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfc110",
  null
  
)

export default component.exports